import { labels } from "./config.js";

export function setBusy(form, busy, busyLabel) {
	const button = form?.querySelector("[data-auth-submit]");
	if (!button) return;
	if (!button.dataset.idleLabel) button.dataset.idleLabel = button.textContent.trim();
	button.disabled = busy;
	button.setAttribute("aria-busy", String(busy));
	button.textContent = busy ? busyLabel : button.dataset.idleLabel;
}

export function setActionLabel(form, label) {
	const button = form?.querySelector("[data-auth-submit]");
	if (!button) return;
	button.textContent = label;
	button.dataset.idleLabel = label;
}

export function showNotice(root, message, tone = "error") {
	const slot = root?.querySelector("[data-auth-notice-slot]");
	if (!slot) return;
	slot.replaceChildren();
	if (!message) return;
	const notice = document.createElement("div");
	notice.className = `syscofy-auth-notice syscofy-auth-notice--${tone}`;
	notice.setAttribute("role", tone === "success" ? "status" : "alert");
	notice.textContent = message;
	slot.append(notice);
}

export function showFieldError(input, message) {
	const field = input?.closest("[data-auth-field]");
	const error = field?.querySelector("[data-auth-field-error]");
	if (!error) return;
	error.textContent = message;
	error.hidden = !message;
	input.setAttribute("aria-invalid", message ? "true" : "false");
}

export function clearFieldError(input) {
	showFieldError(input, "");
}

export function showView(name) {
	document.querySelectorAll("[data-auth-view]").forEach((view) => {
		view.hidden = view.dataset.authView !== name;
	});
}

export function bindFieldCleanup(root = document) {
	root.querySelectorAll(".syscofy-auth-control").forEach((input) => {
		input.addEventListener("input", () => clearFieldError(input));
	});
}

export function bindPasswordToggles(root = document) {
	root.querySelectorAll("[data-auth-password-toggle]").forEach((toggle) => {
		const input = document.getElementById(toggle.getAttribute("aria-controls"));
		if (!input) return;
		toggle.addEventListener("click", () => {
			const visible = input.type === "password";
			input.type = visible ? "text" : "password";
			toggle.setAttribute("aria-pressed", String(visible));
			toggle.setAttribute("aria-label", visible ? labels.hidePassword : labels.showPassword);
			input.focus({ preventScroll: true });
		});
	});
}

export function validateEmail(input, { allowAdministrator = false } = {}) {
	if (!input.value.trim()) return labels.emailRequired;
	if (allowAdministrator && input.value.trim() === "Administrator") return "";
	return input.validity.typeMismatch ? labels.invalidEmail : "";
}
